import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { AgControlComponent, AgControlComponentParams, noop } from './ag-control.component';
import { InputComponent } from '../../components/input/input.component';

type AgDatepickerComponentParams = AgControlComponentParams;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, InputComponent, AsyncPipe],
  template: `
    @if (formGroup$ | async) {
      <div [formGroup]="$any(formGroup$ | async)">
        @if (isReady$ | async) {
          <aux-input
            class="w-full border-none bg-transparent p-0"
            [inputClassName]="
              hasError ? 'border-aux-red-dark !rounded ' + controlHeightClass : controlHeightClass
            "
            type="date"
            [formControl]="formControl"
            (change)="changeHandler()"
          />
        }
      </div>
    }
  `,
})
export class AgDatepickerComponent extends AgControlComponent {
  params!: AgDatepickerComponentParams;

  agInit(params: AgDatepickerComponentParams): void {
    this.params = params;
    this.value = params.value;
    this.fieldName = params.colDef?.field;
    this.changeHandler = params.changeHandler ?? noop;
    this.updateView(params);
  }
}
